// Generated file : do not modify
export enum TransactionTypes
{
  NONE = 0,
  PRELEVEMENT,
  VIREMENT_EMIS,
  VIREMENT_RECU,
  CARTE_BANCAIRE_EMIS,
  CARTE_BANCAIRE_RECU,
  CHEQUE_EMIS,
  CHEQUE_RECU,
  PROVISION_CAISSE,
  COMPTE_COURANT
};

export enum TransactionStatuts
{
  NONE = 0,
  PROCESSING,
  WAITED,
  RECEIVED,
  DELIVERED,
  EMITTED,
  PAYED,
  BILLED,
  WAITING_REJECT,
  REJECTED,
  WAITING_MANDAT,
  OLD_WAITING_FUNDING,
  GENERATION_ERROR
};

import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Transactions financières
export class TransactionBank {
  // Transactions
  public transactionIds: number[];
  // Banklogs
  public bankLogIds: number[];
  // Etablissement
  public etablissementId: number;

  constructor() {
    this.transactionIds = [];
    this.bankLogIds = [];
    this.etablissementId = 0;
  }
}

export default class Transaction  {
  // Identifiant unique
  public id: number;
  // Mode de règlement
  public type: TransactionTypes;
  // Code CI98
  public code: number;
  // Moyen de paiement (ribId ou CB)
  public typeId: number;
  // Référence
  public reference: string;
  // Information
  public info: string;
  // Montant
  public amount: number;
  // Owner
  public owner: Owner;
  // Type de la source
  public sourceType: ObjTypes;
  // Identifiant de la source
  public sourceId: number;
  // Statut
  public statut: TransactionStatuts;
  // Date de demande
  public dateTransaction: Date;
  // Date d'émission ou de réception
  public dateProcess: Date | null;
  // Date d'encaissement
  public datePayed: Date | null;
  // Bordereau bancaire
  public deliveryId: number;
  // Ecriture en banque
  public bankId: number;
  // Moyen de paiement
  public paymentMeans: string;
  // Document associe
  public documentId: number;
  // Etablissement associe
  public etablissementId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.type = TransactionTypes.NONE;
    this.code = 0;
    this.typeId = 0;
    this.reference = '';
    this.info = '';
    this.amount = 0;
    this.owner = new Owner();
    this.sourceType = ObjTypes.NONE;
    this.sourceId = 0;
    this.statut = TransactionStatuts.NONE;
    this.dateTransaction = new Date(1901,1,1,0,0,0,0);
    this.dateProcess = null;
    this.datePayed = null;
    this.deliveryId = 0;
    this.bankId = 0;
    this.paymentMeans = '';
    this.documentId = 0;
    this.etablissementId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Transaction): Transaction {
    const newTransaction: Transaction = new Transaction();
    newTransaction.id = obj.id;
    newTransaction.type = obj.type;
    newTransaction.code = obj.code;
    newTransaction.typeId = obj.typeId;
    newTransaction.reference = obj.reference;
    newTransaction.info = obj.info;
    newTransaction.amount = obj.amount;
    newTransaction.owner = JSON.parse(JSON.stringify(obj.owner));
    newTransaction.sourceType = obj.sourceType;
    newTransaction.sourceId = obj.sourceId;
    newTransaction.statut = obj.statut;
    newTransaction.dateTransaction = new Date(obj.dateTransaction);
    newTransaction.dateProcess = obj.dateProcess ? new Date(obj.dateProcess) : null;
    newTransaction.datePayed = obj.datePayed ? new Date(obj.datePayed) : null;
    newTransaction.deliveryId = obj.deliveryId;
    newTransaction.bankId = obj.bankId;
    newTransaction.paymentMeans = obj.paymentMeans;
    newTransaction.documentId = obj.documentId;
    newTransaction.etablissementId = obj.etablissementId;
    newTransaction.createId = obj.createId;
    newTransaction.failed = obj.failed;
    newTransaction.canUpdate = obj.canUpdate;
    newTransaction.canDelete = obj.canDelete;
    newTransaction.display = obj.display;
    newTransaction.notifDefType = obj.notifDefType;
    newTransaction.ownerType = obj.ownerType;
    newTransaction.ownerId = obj.ownerId;
    newTransaction.ownerLabel = obj.ownerLabel;
    return newTransaction;
  }

  public toJsonTransaction (): string {
    const json = {
      type: this.type,
      code: this.code,
      typeId: this.typeId,
      reference: this.reference,
      info: this.info,
      amount: this.amount,
      owner: this.owner,
      sourceType: this.sourceType,
      sourceId: this.sourceId,
      statut: this.statut,
      dateTransaction: this.dateTransaction ? new Date (this.dateTransaction).toString() : this.dateTransaction,
      dateProcess: this.dateProcess ? new Date (this.dateProcess).toString() : this.dateProcess,
      datePayed: this.datePayed ? new Date (this.datePayed).toString() : this.datePayed,
      deliveryId: this.deliveryId,
      bankId: this.bankId,
      paymentMeans: this.paymentMeans,
      documentId: this.documentId,
      etablissementId: this.etablissementId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromTransaction (obj: Transaction): void {
    this.id = obj.id;
    this.type = obj.type;
    this.code = obj.code;
    this.typeId = obj.typeId;
    this.reference = obj.reference;
    this.info = obj.info;
    this.amount = obj.amount;
    this.owner = obj.owner;
    this.sourceType = obj.sourceType;
    this.sourceId = obj.sourceId;
    this.statut = obj.statut;
    this.dateTransaction = new Date(obj.dateTransaction);
    this.dateProcess = obj.dateProcess;
    this.datePayed = obj.datePayed;
    this.deliveryId = obj.deliveryId;
    this.bankId = obj.bankId;
    this.paymentMeans = obj.paymentMeans;
    this.documentId = obj.documentId;
    this.etablissementId = obj.etablissementId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareTransaction (value: Transaction): boolean {
    return (this.toJsonTransaction() == value.toJsonTransaction());
  }

  public cloneTransaction (): Transaction {
    return Transaction.fromJson(this);
  }

  public createForStoreTransaction (): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromTransaction(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreTransaction (): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/transactions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromTransaction(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static delivered (transaction: Transaction): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/delivered', transaction, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Transaction.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static generateBill (owner: Owner): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/generateBill', owner, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static waitedList (transaction: Transaction): Promise<Transaction[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/waitedList', transaction, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Transaction[] = [];
              res.data.forEach(( a: Transaction ) => {
                cData.push(Transaction.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static simuBank (transactions: Transaction[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/simuBank', transactions, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static rapproche (transaction: Transaction): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/rapproche', transaction, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static link (transactionBank: TransactionBank): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/transactions/link', transactionBank, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Transactions/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Transaction.fromJson(listData.reccords[0] as Transaction);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Transactions/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Transaction.fromJson(listData.reccords[0] as Transaction);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(transactions: Transaction[]) {
    transactions.forEach((item) => {
      item.dateTransaction = item.dateTransaction ? new Date(item.dateTransaction) : item.dateTransaction;
      item.dateProcess = item.dateProcess ? new Date(item.dateProcess) : item.dateProcess;
      item.datePayed = item.datePayed ? new Date(item.datePayed) : item.datePayed;
    })
  }
}
